import { Component, OnInit, Input, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { Transaction, Bank, Payment } from '../../models';
import { AuthService } from '../../services/auth.service';
import { PseTransaction } from '../../models/pse-transaction';
import { PseService } from '../../services/pse.service';
import { PayService } from '../../services/pay.service';
import { AlertService } from '../../services/alert.service';
import { TokenServiceService } from '../../services/token-service.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ALERT_ERRORS, PSE_VALIDATION } from '../../core/constants/Errors';
import { DOC_TYPES, DOC_TYPES_BY_CLIENT_TYPE } from '../../core/constants/FormLists';
import { LEGAL_FILES } from '../../core/constants/URLs';
import { isString } from 'lodash';
import { EmailValidator } from '../../tools/email-validator';
import { BUYER_INFORMATION_VALIDATIONS } from '../../core/constants/Errors';
import { PayvalidaFeatureFlagService } from 'src/app/services/payvalida-feature-flag.service';
import { ALERT_ICON_CONSTANTS, AUTOCOMPLETE_FORM_CONTROLS, AUTOCOMPLETE_METHOD_PAY_TYPES, FLAGS_NAME, GENERAL_CONSTANTS, PCOL_TRANSACTION_KEYS, TYPE_CLIENTS } from 'src/app/core/constants/General-constants';
import { PatchValAdditionalInfoService } from 'src/app/services/patch-val-additional-info.service';
import { EMAIL_LENGTH, MAX_MIN_ADDRESS_INPUT, MAX_MIN_LENGTH_PHONE_INPUT_PSE } from 'src/app/constants/users.constants';
import { SweetAlertIcon } from 'sweetalert2';

export interface AddressInfo {
    line1: string;
    line2: string;
    postalCode: string;
}

@Component({
    selector: 'app-pse',
    templateUrl: './pse.component.html',
    styleUrls: ['./pse.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class PseComponent implements OnInit {
    @Input() info: Payment;
    @Output() PSE = new EventEmitter();

    listBanks: Bank[];
    pseTransaction: PseTransaction;
    transaction: Transaction;
    orderID: string;
    loading: boolean;
    template: string;
    form: FormGroup;
    errorMessages = PSE_VALIDATION;
    listOfDocuments = [];
    personalDataURL = LEGAL_FILES.PERSONAL_DATA;
    errorsMessages = BUYER_INFORMATION_VALIDATIONS;
    pse_url: string;
    pse_window: Window;

    by_pseavanza: boolean;
    validate_document: boolean = false;
    formPrivacyValid: boolean = false;

    objectControlData = [
        {
            formControl: 'name',
            readOnly: false,
        },
        {
            formControl: 'bank',
            readOnly: false,
        },
        {
            formControl: 'lastname',
            readOnly: false,
        },
        {
            formControl: 'typeDI',
            readOnly: false,
        },
        {
            formControl: 'di',
            readOnly: false,
        },
        {
            formControl: 'cellPhone',
            readOnly: false,
        },
        {
            formControl: 'email',
            readOnly: false,
        },
        {
            formControl: 'billAddrLine1',
            readOnly: false,
        },
        {
            formControl: 'billAddrLine2',
            readOnly: false,
        },
        {
            formControl: 'billAddrPostCode',
            readOnly: false,
        },
    ];
    addressInfo: AddressInfo;
    typeClients = TYPE_CLIENTS;
    isEditableInfo = false;
    selectedPersonType: string;

    private tokenInfoFlagParameter = 'pse-checkout';
    psetokenInfofFFEnabled: boolean = false;

    private pseSelectDocTypeByPersonTypeParameter = 'pseSelectDocByPersonType';
    pseSelectDocTypeByPersonTypeFf: boolean = false;

    fixAutocompleteTokenPersonalInfoFF: boolean = false;
    enablePsePopUp: boolean = false;

    constructor(
        private readonly authService: AuthService,
        private readonly pseservice: PseService,
        private readonly payservice: PayService,
        private readonly alertService: AlertService,
        private readonly tokenServiceService: TokenServiceService,
        private readonly formBuilder: FormBuilder,
        private tokenService: TokenServiceService,
        private featureFlagService: PayvalidaFeatureFlagService,
        private readonly patchValAdditionalInfoService: PatchValAdditionalInfoService
    ) {
        this.form = this.formBuilder.group({
            typeDI: ['', Validators.required],
            di: ['', Validators.compose([Validators.required, Validators.maxLength(20), Validators.minLength(6), Validators.pattern('^[0-9-]*$')])],
            cellPhone: [''],
            email: [''],
            address: [''],
            name: ['', Validators.compose([Validators.required, Validators.maxLength(100), Validators.pattern('^[A-Za-zñÑáéíóúÁÉÍÓÚ. ]*$')])],
            lastName: ['', Validators.compose([Validators.required, Validators.maxLength(100), Validators.pattern('^[A-Za-zñÑáéíóúÁÉÍÓÚ. ]*$')])],
            personType: ['', Validators.required],
            bank: ['', Validators.required],
            token: ['', Validators.required],
        });
    }

    ngOnInit() {
        this.transaction = this.tokenServiceService.getAndDecodeToken();

        this.featureFlagService.getFeatureFlagValue(this.tokenInfoFlagParameter, FLAGS_NAME.PSE_TOKEN_INFO_FF, GENERAL_CONSTANTS.PAYVALIDA_FF_PLATFORM).subscribe((response: boolean) => {
            this.psetokenInfofFFEnabled = response;
        });

        let param: string = Object.values(GENERAL_CONSTANTS.TEST_MERCHANTS).includes(this.transaction.MERCHANT_ID) ? this.transaction.MERCHANT_ID : `${this.transaction.ORDER_CODE}`;

        this.featureFlagService.getFeatureFlagValue(param, FLAGS_NAME.ENABLE_PSE_POPUP, GENERAL_CONSTANTS.PAYVALIDA_FF_PLATFORM).subscribe((response: boolean) => {
            this.enablePsePopUp = response;
        });

        this.featureFlagService.getFeatureFlagValue(this.pseSelectDocTypeByPersonTypeParameter, FLAGS_NAME.PSE_CHANGE_DOC_TYPE_PERSON_TYPE_FF, GENERAL_CONSTANTS.PAYVALIDA_FF_PLATFORM).subscribe((response: boolean) => {
            this.pseSelectDocTypeByPersonTypeFf = response;
        });

        this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.FIX_AUTOCOMPLETE_TOKEN_PERSONAL_INFO, FLAGS_NAME.FIX_AUTOCOMPLETE_TOKEN_PERSONAL_INFO, GENERAL_CONSTANTS.PAYVALIDA_FF_PLATFORM).subscribe((response: boolean) => {
            this.fixAutocompleteTokenPersonalInfoFF = response;
        });

        if (!this.pseSelectDocTypeByPersonTypeFf) {
            const docTypesObjectKeys = Object.keys(DOC_TYPES);

            for (let prop of docTypesObjectKeys) {
                this.listOfDocuments.push(DOC_TYPES[prop]);
            }
        }

        this.onActivate();

        this.template = this.info.template;
        this.loading = true;
        this.by_pseavanza = false;
        this.orderID = this.authService.getOrderID();

        const parameters = {
            token: this.tokenServiceService.getToken(),
        };

        this.pseTransaction = new PseTransaction();
        this.pseTransaction.name = this.transaction.USER_NAME;
        this.pseTransaction.lastName = this.transaction.USER_LAST_NAME;
        this.pseTransaction.di = this.transaction.USER_DI;
        this.pseTransaction.typeDI = this.transaction.USER_TYPE_DI;

        this.pseservice.getListBancPost(parameters).subscribe((data: any) => {
            this.loading = false;
            this.pseTransaction.token = parameters.token;
            this.form.patchValue(this.pseTransaction);

            if (data.statusCode === 201) {
                this.by_pseavanza = data.nf;

                if (this.by_pseavanza) {
                    this.form.controls[AUTOCOMPLETE_FORM_CONTROLS.ADDRESS].setValidators([
                        Validators.required,
                        Validators.minLength(MAX_MIN_ADDRESS_INPUT.MIN),
                        Validators.maxLength(MAX_MIN_ADDRESS_INPUT.MAX),
                        Validators.pattern(GENERAL_CONSTANTS.PATTERN.ADDRESS),
                    ]);

                    this.form.controls[AUTOCOMPLETE_FORM_CONTROLS.EMAIL].setValidators([Validators.required, EmailValidator.isValid, Validators.maxLength(EMAIL_LENGTH.MAX)]);

                    this.form.controls[AUTOCOMPLETE_FORM_CONTROLS.CELLPHONE].setValidators([
                        Validators.required,
                        Validators.pattern(GENERAL_CONSTANTS.PATTERN.ONLY_NUMBER),
                        (control) => {
                            const pseLength = MAX_MIN_LENGTH_PHONE_INPUT_PSE.MIN_MAX;
                            const value = control.value as string;

                            if (value.length > pseLength) {
                                return { colMaxLength: true };
                            }

                            if (value.length != GENERAL_CONSTANTS.NUMBER_ZERO && value.length < pseLength) {
                                return { colMinLength: true };
                            }

                            return null;
                        },
                    ]);
                }

                this.listBanks = data.body.filter((bank) => {
                    return bank.BANK_CODE !== GENERAL_CONSTANTS.STRING_ZERO;
                });

                if (this.psetokenInfofFFEnabled) this.disabledItems();
            } else {
                this.loading = false;

                this.alertService.showAlert(GENERAL_CONSTANTS.PSE_TRANSACTION_ERROR_ALERT, ALERT_ICON_CONSTANTS.WARNING as SweetAlertIcon);

                this.changeMethod();
            }
        });
    }
    /**
     *
     * @description {formPrivacyUpdate} Function that obtains the event of the validation of the child component
     * @param valid
     */
    formPrivacyUpdate = (valid: boolean) => {
        this.formPrivacyValid = valid;
    };
    /**
     *
     * @description {completedForms} Function to validate the validations of the parent component and child component
     * @returns
     */
    completedForms = (): boolean => {
        return this.form.valid && this.formPrivacyValid;
    };

    async validData() {
        this.loading = true;
        this.pseTransaction = this.form.value;
        this.pseTransaction.di = this.pseTransaction.di.toString();
        if (this.completedForms()) {
            localStorage.setItem(`${PCOL_TRANSACTION_KEYS.PCO_INFO_ACUMMULATE_POINTS}-${this.transaction.ORDER_REFERENCE}`, JSON.stringify(this.pseTransaction));
            return await this.processPayment();
        }

        this.loading = false;

        this.alertService.showAlert(ALERT_ERRORS.DATA_IMCOMPLETED, ALERT_ICON_CONSTANTS.WARNING);
    }

    async processPayment() {
        try {
            if (this.enablePsePopUp) return await this.openPsePopUp();

            const pseResponse: any = await this.payservice.pseTransaction(this.pseTransaction);
            this.loading = false;
            if (pseResponse.statusCode === 201) {
                window.location.href = pseResponse.body.URL_BANK;
            } else {
                this.loading = false;
                if (pseResponse.message != null && isString(pseResponse.message)) {
                    this.alertService.showAlert(pseResponse.message, 'error');
                } else {
                    this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, 'error');
                }
            }

        } catch (e) {
            this.loading = false;
            this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, 'error');
        }
    }

    async openPsePopUp() {
        try {
            if (this.pse_url) {
                this.openAndMonitorWindow(this.pse_url, GENERAL_CONSTANTS.PSE_STRING);

                return;
            }

            this.loading = true;

            const response: any = await this.payservice.pseTransaction(this.pseTransaction);


            if (response.statusCode !== GENERAL_CONSTANTS.CREATED_RESPONSE_CODE) {
                return this.handleErrorResponse(response);
            }

            this.pse_url = response.body.URL_BANK;

            this.openAndMonitorWindow(this.pse_url, GENERAL_CONSTANTS.PSE_STRING);
        } catch (_) {
            this.loading = false;

            this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, ALERT_ICON_CONSTANTS.ERROR as SweetAlertIcon);
        }
    }

    openAndMonitorWindow(url: string, windowTitle: string) {
        const screenWidth = window.innerWidth - (window.innerWidth * 0.1);
        const screenHeight = window.innerHeight - (window.innerHeight * 0.2);

        let left = (screen.width - screenWidth) / 2;
        let top = screen.height - (screen.height * 0.8);
        let popupUrl = `${window.location.origin}/popup-service?url=${url}`

        const pseWindow = window.open(popupUrl, windowTitle, `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=${screenWidth},height=${screenHeight},left=${left},top=${top}`);

        if (!pseWindow) {
            this.loading = false;

            if (window.parent === window) return window.location.href = url;

            return this.alertService.showAlert(ALERT_ERRORS.POP_UP_BLOCKED, ALERT_ICON_CONSTANTS.WARNING as SweetAlertIcon);
        }

        const interval = setInterval(() => {
            try {
                if (pseWindow.closed) {
                    this.loading = false;

                    this.alertService.showAlert(ALERT_ERRORS.PROCESS_WAS_NOT_FINISHED, ALERT_ICON_CONSTANTS.WARNING as SweetAlertIcon);

                    clearInterval(interval);
                }

                if (pseWindow.location.host === window.location.host && pseWindow.location.pathname === '/checkout/alertpse') {
                    window.location.href = pseWindow.location.href;

                    pseWindow.close();

                    clearInterval(interval);
                }
            } catch (_) {
                // Do nothing
            }
        }, 1000);
    }

    handleErrorResponse(response: any) {
        this.loading = false;

        if (response.message != null && isString(response.message)) {
            this.alertService.showAlert(response.message, ALERT_ICON_CONSTANTS.ERROR as SweetAlertIcon);
            return;
        }

        this.alertService.showAlert(ALERT_ERRORS.UNEXPECTED_ERROR, ALERT_ICON_CONSTANTS.ERROR as SweetAlertIcon);
    }

    changeMethod() {
        this.PSE.emit();
    }

    onActivate() {
        window.scroll(0, 0);
    }

    validDI() {
        if (this.form.value.di.includes('-')) {
            const expresion = /^([0-9]+-{1}[0-9]{1})$/i;
            if (!expresion.test(this.form.value.di)) {
                this.validate_document = true;
            } else {
                this.validate_document = false;
            }
        }
    }

    /**
     *
     * @description {disabledItems} Function to disabled items to checkout form
     */
    disabledItems() {
        try {
            let additionalInfo = this.tokenService.exitsAdditionalInformation(this.transaction);
            if (additionalInfo) {
                this.isEditableInfo = this.tokenService.isEditableInfo(additionalInfo);
                if (this.fixAutocompleteTokenPersonalInfoFF)
                    return (this.addressInfo = this.patchValAdditionalInfoService.patchValAdditionalInfo(
                        this.isEditableInfo,
                        additionalInfo,
                        this.form,
                        AUTOCOMPLETE_METHOD_PAY_TYPES.PSE,
                        this.objectControlData
                    ));

                this.patchValAdditionalInfo(this.isEditableInfo, additionalInfo);
                return;
            }
        } catch (_) {
            this.alertService.showAlert(ALERT_ERRORS.GET_TOKEN_DATA_ERROR);
        }
    }
    /**
     * @description {patchValAdditionalInfo} Function to map the values of the PSE form with the additional information of the token
     */
    patchValAdditionalInfo(isEditableInfo: boolean, additionalInformation: any) {
        isEditableInfo = isEditableInfo ? false : true;
        const { client } = additionalInformation;
        const { personal_information } = client;
        const { address } = client;
        const { contact_information } = personal_information;
        this.addressInfo = address ? address : '';

        if (personal_information && personal_information.firstname) {
            this.form.controls.name.setValue(personal_information.firstname);
            this.objectControlData.find((m) => m.formControl === 'name').readOnly = isEditableInfo;
        }

        if (personal_information && personal_information.lastname) {
            this.form.get('lastName').setValue(personal_information.lastname);
            this.objectControlData.find((m) => m.formControl === 'lastname').readOnly = isEditableInfo;
        }

        if (personal_information && personal_information.document.type) {
            this.form.controls.typeDI.setValue(personal_information.document.type);
            this.objectControlData.find((m) => m.formControl === 'typeDI').readOnly = isEditableInfo;
        }

        if (personal_information && personal_information.document.id) {
            this.form.controls.di.setValue(personal_information.document.id);
            this.objectControlData.find((m) => m.formControl === 'di').readOnly = isEditableInfo;
        }

        if (contact_information && contact_information.phone) {
            this.form.controls.cellPhone.setValue(contact_information.phone);
            this.objectControlData.find((m) => m.formControl === 'cellPhone').readOnly = isEditableInfo;
        }

        if (contact_information && contact_information.email) {
            this.form.controls.email.setValue(contact_information.email);
            this.objectControlData.find((m) => m.formControl === 'email').readOnly = isEditableInfo;
        }

        if (address && address.line1) {
            this.form.controls.address.setValue(address.line1);
            this.objectControlData.find((m) => m.formControl === 'billAddrLine1').readOnly = isEditableInfo;
        }
    }
    /**
     *
     * @description {isControlReadOnly} function to check if form fields are read-only
     * @param controlName
     * @returns
     */
    isControlReadOnly(controlName: string): boolean {
        const readOnlyControl = this.objectControlData.find((m) => m.formControl === controlName);
        return readOnlyControl ? readOnlyControl.readOnly : false;
    }

    /**
     * @description This method determines whether the list of available document types
     * should be updated based on the selected person type.
     */
    onPersonTypeChange() {
        if (!this.pseSelectDocTypeByPersonTypeFf) {
            return;
        }

        this.selectedPersonType = this.form.get('personType').value;

        if (!this.selectedPersonType) return;

        this.listOfDocuments = Object.values(DOC_TYPES_BY_CLIENT_TYPE[this.selectedPersonType]);
    }
}
